import styled from 'styled-components';

export const Container = styled.div`
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 500px;

  span.apexcharts-tooltip-text-y-value {
    color: #fff;
  }
  span.apexcharts-tooltip-text-y-label {
    color: #fff;
  }
`;
